import {
  createTheme as baseCreateMuiTheme,
  ThemeProvider as MuiThemeProvider,
  Theme,
  useTheme,
} from '@mui/material/styles';

export { MuiThemeProvider, Theme, useTheme, baseCreateMuiTheme };
